function formatTsForUi(value, isRu = false) {
  if (!value) {
    return '';
  }
  const raw = String(value);
  const withZone = raw.includes('+') || raw.endsWith('Z') ? raw : `${raw}+00:00`;
  const dt = new Date(withZone);
  if (Number.isNaN(dt.getTime())) {
    return raw;
  }
  return dt.toLocaleString(isRu ? 'ru-RU' : 'en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function buildUploadsByTask(rows = []) {
  const byTask = new Map();
  rows.forEach((row) => {
    const taskId = Number(row?.test_instance_task_id || 0);
    if (!taskId) {
      return;
    }
    if (!byTask.has(taskId)) {
      byTask.set(taskId, []);
    }
    byTask.get(taskId).push(row);
  });
  return byTask;
}

export function buildWrittenUploadPreviewSources(relativePath, assetsBaseUrl = '') {
  const source = relativePath && typeof relativePath === 'object' ? relativePath : {relative_path: relativePath};
  const explicitOriginalUrl = String(source?.original_url || '').trim();
  const explicitWebpUrl = String(source?.webp_url || '').trim();
  const normalizedPath = String(source?.relative_path || relativePath || '').trim();
  const normalizedBase = String(assetsBaseUrl || '').trim().replace(/\/+$/, '');
  if (explicitOriginalUrl || explicitWebpUrl) {
    return {
      originalPath: normalizedPath,
      webpPath: String(source?.webp_path || '').trim() || normalizedPath.replace(/\.[^.\/]+$/, '.webp'),
      originalUrl: explicitOriginalUrl,
      webpUrl: explicitWebpUrl,
    };
  }
  if (!normalizedPath) {
    return {
      originalPath: '',
      webpPath: '',
      originalUrl: '',
      webpUrl: '',
    };
  }
  const webpPath = normalizedPath.replace(/\.[^.\/]+$/, '.webp');
  const prefix = normalizedBase || '';
  return {
    originalPath: normalizedPath,
    webpPath,
    originalUrl: `${prefix}${normalizedPath}`,
    webpUrl: `${prefix}${webpPath}`,
  };
}

export function buildUploadedSummaryText(summary = {}, isRu = false) {
  const totalPhotos = Number(summary.total_photos || 0);
  const uniqueTasks = Number(summary.unique_tasks || 0);
  return isRu
    ? `Сохранено фотографий: ${totalPhotos}. Уникальных задач с фотографиями: ${uniqueTasks}.`
    : `Saved photos: ${totalPhotos}. Unique tasks with photos: ${uniqueTasks}.`;
}

export function renderUploadedSummary(summary = {}, elements = [], isRu = false) {
  const text = buildUploadedSummaryText(summary, isRu);
  elements.forEach((element) => {
    if (!element) {
      return;
    }
    element.textContent = text;
    element.classList.remove('hidden');
  });
  return text;
}

export function buildUploadedFilesHtml(rows = [], isRu = false) {
  if (!rows.length) {
    return `<p>${isRu ? 'Пока нет сохранённых фотографий.' : 'No saved photos yet.'}</p>`;
  }

  const grouped = {};
  rows.forEach((row) => {
    const taskNum = Number(row.order_index || 0);
    if (!grouped[taskNum]) {
      grouped[taskNum] = [];
    }
    grouped[taskNum].push(row);
  });

  return Object.keys(grouped)
    .map((taskNumRaw) => Number(taskNumRaw))
    .sort((a, b) => a - b)
    .map((taskNum) => {
      const taskRows = grouped[taskNum];
      const title = taskRows[0]?.title_snapshot || '';
      const filesHtml = taskRows
        .map((row) => {
          const filename = row.orig_filename || row.img_hash;
          const ts = formatTsForUi(row.ts, isRu);
          return `<li>${filename}${ts ? ` (${ts})` : ''}</li>`;
        })
        .join('');
      return `
        <div class="mb-2">
          <div><b>${isRu ? 'Задача' : 'Task'} ${taskNum}${title ? `: ${title}` : ''}</b> (${taskRows.length})</div>
          <ul class="list-disc pl-5">${filesHtml}</ul>
        </div>
      `;
    })
    .join('');
}

export function renderUploadedFiles(rows = [], {wrapperEl = null, listEl = null, isRu = false} = {}) {
  if (!listEl) {
    return '';
  }
  const html = buildUploadedFilesHtml(rows, isRu);
  listEl.innerHTML = html;
  if (wrapperEl) {
    wrapperEl.classList.remove('hidden');
  }
  return html;
}
